import api from "./api";

const getAllByWoIdPaginated = (woId, pageNumber) => {
  return api.get("/api/history/get_all_by_wo_id_paginated", {
    params: { woId, pageNumber },
  });
};

const HistoryService = {
  getAllByWoIdPaginated,
};

export default HistoryService;